<script lang="ts">
	import { NewsViewPage } from '#lib/websites/news/pages/NewsViewPage/index.js';
</script>

<NewsViewPage />
